import script from "./Files.vue?vue&type=script&setup=true&lang=js"
export * from "./Files.vue?vue&type=script&setup=true&lang=js"

import "./Files.vue?vue&type=style&index=0&id=2723c017&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2723c017"]])

export default __exports__